import { MasterTemplate, ScaleResume } from '@sr/templates/src';
import { Resume } from '@sr/types';
import React from 'react';
import { Box } from '../../ui';
import HelpButton from '../help/HelpButton';

const ResumePreviewContainer = ({
  resume,
  localBaseSize,
}: {
  resume: Resume;
  localBaseSize: number;
}) => {
  return (
    <>
      <Box
        sx={{ maxWidth: [null, null, 800], mt: 6, mb: 8, userSelect: 'none' }}
      >
        <ScaleResume>
          <MasterTemplate
            resume={resume}
            paged={true}
            localBaseSize={localBaseSize}
            forceBreakpoint="desktop"
          />
          <style>{`
            #pdfResume {
              margin-left: auto;
              margin-right: auto;
            }
            .pdf-page {
              margin-bottom: 10px;
            }
          `}</style>
        </ScaleResume>
        <HelpButton userId={resume.owner} isDark={true} />
      </Box>
    </>
  );
};

export default ResumePreviewContainer;
